export default __webpack_public_path__ + "static/media/sd-event-3.2eaf7254.webp";